jQuery(document).ready(function() {
	jQuery('.aeroToUpperCase').keypress(function(e) {

		var code = (e.keyCode ? e.keyCode : e.which);

		if (code == 287 || code == 286) {
			this.value += 'G';
		} else if (code == 252 || code == 220) {
			this.value += 'U';
		} else if (code == 304 || code == 105) {
			this.value += 'I';
		} else if (code == 351 || code == 350) {
			this.value += 'S';
		} else if (code == 231 || code == 199) {
			this.value += 'C';
		} else if (code == 246 || code == 214) {
			this.value += 'O';
		}
	});

	jQuery('.aeroToUpperCase').keyup(function() {
		this.value = this.value.toUpperCase();
		this.value = this.value.replace(/([^A-Z ])/g, "");
	});

	jQuery('.aeroAlphabetic').keyup(function() {
		this.value = this.value.replace(/([^A-Z ])/g, "");
	});

	jQuery('.aeroLowerTurkish').keypress(function(e) {

		var code = (e.keyCode ? e.keyCode : e.which);

		if (code == 287 || code == 286) {
			this.value += 'g';
		} else if (code == 252 || code == 220) {
			this.value += 'u';
		} else if (code == 305) {
			this.value += 'i';
		} else if (code == 351 || code == 350) {
			this.value += 's';
		} else if (code == 231 || code == 199) {
			this.value += 'c';
		} else if (code == 246 || code == 214) {
			this.value += 'o';
		}

	});

	jQuery('.aeroLowerTurkish').keyup(function() {
		this.value = this.value.toLowerCase();
		this.value = this.value.replace(/([Ç,ç,Ü,ü,İ,ı,Ğ,ğ,Ö,ö,Ş,ş])/g, "");
	});
});
